import AddProgram from "../../Components/Modals/AddProgram";
import Table from "../../Components/Table";
import { deleteProgramById, getAllAchievement } from "../../Services/MasterService";

const Programs = () => {
  const columns = [
    {
      label: "Name",
      value: "name"
    },
    {
      label: "Category",
      value: "category_name"
    },
  ];

  const renderAddModal = (openAddModal, setOpenAddModal) => {
    return (
      <AddProgram data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
    )
  };

  return (
    <Table
      api={getAllAchievement}
      columns={columns}
      title={"Programs Master"}
      redirectAdd={"/addProgram"}
      addModal={renderAddModal}
      showAddButton={true}
      showExportButton={true}
      deleteApi={deleteProgramById}
    />
  );
}

export default Programs;
